{
  "title": "Asteroid Atlas",
  "loading": {
    "progress": "Loading Earth..."
  },
  "navigation": {
    "title": "Navigate to Coordinates",
    "latitude": "Lat:",
    "longitude": "Lon:",
    "latitude_placeholder": "Latitude",
    "longitude_placeholder": "Longitude",
    "go_to_location": "Go to Location",
    "add_marker": "Add Marker",
    "my_location": "📍 My Location",
    "quick_locations": "Quick Locations:",
    "click_instruction": "Click on Earth to get coordinates at that point"
  },
  "locations": {
    "london": "London",
    "tokyo": "Tokyo",
    "washington": "Washington",
    "new_york": "New York",
    "paris": "Paris",
    "rio_de_janeiro": "Rio de Janeiro",
    "cairo": "Cairo",
    "mumbai": "Mumbai",
    "moscow": "Moscow",
    "cape_town": "Cape Town",
    "beijing": "Beijing",
    "los_angeles": "Los Angeles",
    "dubai": "Dubai",
    "singapore": "Singapore",
    "reykjavik": "Reykjavik",
    "greenwich": "Greenwich (0°,0°)",
    "null_island": "Null Island (0°,0°)"
  },
  "countries": {
    "united_states": "United States",
    "united_kingdom": "United Kingdom", 
    "japan": "Japan",
    "australia": "Australia",
    "france": "France",
    "brazil": "Brazil",
    "egypt": "Egypt",
    "india": "India",
    "russia": "Russia",
    "south_africa": "South Africa",
    "china": "China",
    "united_arab_emirates": "United Arab Emirates",
    "singapore": "Singapore",
    "iceland": "Iceland",
    "canada": "Canada",
    "germany": "Germany",
    "italy": "Italy",
    "spain": "Spain",
    "mexico": "Mexico",
    "argentina": "Argentina",
    "chile": "Chile",
    "peru": "Peru",
    "colombia": "Colombia",
    "venezuela": "Venezuela",
    "norway": "Norway",
    "sweden": "Sweden",
    "finland": "Finland",
    "denmark": "Denmark",
    "netherlands": "Netherlands",
    "belgium": "Belgium",
    "switzerland": "Switzerland",
    "austria": "Austria",
    "poland": "Poland",
    "czech_republic": "Czech Republic",
    "hungary": "Hungary",
    "romania": "Romania",
    "bulgaria": "Bulgaria",
    "greece": "Greece",
    "turkey": "Turkey",
    "israel": "Israel",
    "saudi_arabia": "Saudi Arabia",
    "iran": "Iran",
    "iraq": "Iraq",
    "afghanistan": "Afghanistan",
    "pakistan": "Pakistan",
    "bangladesh": "Bangladesh",
    "sri_lanka": "Sri Lanka",
    "myanmar": "Myanmar",
    "thailand": "Thailand",
    "vietnam": "Vietnam",
    "cambodia": "Cambodia",
    "laos": "Laos",
    "malaysia": "Malaysia",
    "indonesia": "Indonesia",
    "philippines": "Philippines",
    "south_korea": "South Korea",
    "north_korea": "North Korea",
    "mongolia": "Mongolia",
    "kazakhstan": "Kazakhstan",
    "uzbekistan": "Uzbekistan",
    "kyrgyzstan": "Kyrgyzstan",
    "tajikistan": "Tajikistan",
    "turkmenistan": "Turkmenistan",
    "ukraine": "Ukraine",
    "belarus": "Belarus",
    "lithuania": "Lithuania",
    "latvia": "Latvia",
    "estonia": "Estonia",
    "new_zealand": "New Zealand",
    "papua_new_guinea": "Papua New Guinea",
    "fiji": "Fiji",
    "somalia": "Somalia",
    "ethiopia": "Ethiopia",
    "kenya": "Kenya",
    "tanzania": "Tanzania",
    "uganda": "Uganda",
    "rwanda": "Rwanda",
    "democratic_republic_of_the_congo": "Democratic Republic of the Congo",
    "angola": "Angola",
    "zambia": "Zambia",
    "zimbabwe": "Zimbabwe",
    "botswana": "Botswana",
    "namibia": "Namibia",
    "madagascar": "Madagascar",
    "mauritius": "Mauritius",
    "seychelles": "Seychelles",
    "morocco": "Morocco",
    "algeria": "Algeria",
    "tunisia": "Tunisia",
    "libya": "Libya",
    "sudan": "Sudan",
    "chad": "Chad",
    "niger": "Niger",
    "mali": "Mali",
    "burkina_faso": "Burkina Faso",
    "ghana": "Ghana",
    "ivory_coast": "Ivory Coast",
    "nigeria": "Nigeria",
    "cameroon": "Cameroon",
    "gabon": "Gabon",
    "central_african_republic": "Central African Republic"
  },
  "regions": {
    "africa": "Africa",
    "europe": "Europe", 
    "asia": "Asia",
    "north_america": "North America",
    "south_america": "South America",
    "oceania": "Oceania",
    "antarctica": "Antarctica",
    "middle_east": "Middle East",
    "caribbean": "Caribbean",
    "central_america": "Central America",
    "eastern_europe": "Eastern Europe",
    "western_europe": "Western Europe",
    "northern_europe": "Northern Europe",
    "southern_europe": "Southern Europe",
    "southeast_asia": "Southeast Asia",
    "east_asia": "East Asia",
    "south_asia": "South Asia",
    "central_asia": "Central Asia",
    "western_asia": "Western Asia",
    "northern_africa": "Northern Africa",
    "eastern_africa": "Eastern Africa",
    "western_africa": "Western Africa",
    "southern_africa": "Southern Africa",
    "central_africa": "Central Africa"
  },
  "coordinates": {
    "format": "{{lat}}°, {{lon}}°",
    "clicked": "Clicked coordinates: {{lat}}, {{lon}}",
    "your_location": "Your location: {{lat}}, {{lon}} (±{{accuracy}}m)",
    "found_location": "Found your location!\\nCoordinates: {{lat}}°, {{lon}}°",
    "found_location_region": "Found your location in {{region}}!\\nCoordinates: {{lat}}°, {{lon}}°",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "region": "Region",
    "distance_to_target": "Distance to target",
    "north": "N",
    "south": "S",
    "east": "E",
    "west": "W"
  },
  "measurements": {
    "kilometers": "km",
    "meters": "m",
    "accuracy": "±{{value}}m"
  },
  "errors": {
    "geolocation_not_supported": "Geolocation is not supported by this browser.",
    "location_permission_denied": "Location access denied by user.",
    "location_unavailable": "Location information is unavailable.",
    "location_timeout": "Location request timed out.",
    "location_unknown": "An unknown error occurred while retrieving location.",
    "invalid_coordinates": "Please enter valid latitude and longitude values",
    "location_lookup_failed": "Location lookup failed"
  },
  "ui": {
    "language": "Language",
    "select_language": "Select Language",
    "control_panel": "Asteroid Impact Simulator",
    "target_coordinates": "Target Coordinates",
    "asteroid_params": "Asteroid Parameters",
    "diameter": "Diameter (m)",
    "speed": "Speed (m/s)",
    "density": "Density (kg/m³)",
    "angle": "Impact Angle (°)",
    "launch_asteroid": "Launch Asteroid",
    "impact_zones": "Impact Zones",
    "impact_energy": "Impact Energy",
    "crater_zone": "Crater (100% destruction)",
    "fireball_zone": "Fireball (50% mortality)",
    "seismic_zone": "Seismic (Meff 7.0)",
    "impact_location": "Impact Location"
  },
  "info": {
    "asteroid_info": "Asteroid Information",
    "earth_info": "Earth Information",
    "loading_data": "Loading data..."
  }
}